import { createContext, useContext } from 'react';

export interface MetaLinksContextValues {
    setLink: (link: string) => void;
}

export const MetaLinksContext = createContext<MetaLinksContextValues>({
    setLink: () => void 0,
});

export const useMetaLinkContext = () => useContext(MetaLinksContext);
